import React from "react"
import styled from "styled-components"
import { MEDIA_QUERIES } from "@constants"

const DropZoneDIV = styled.div`
  height: 60px;
  background: var(--color--cobalt-100);

  ${MEDIA_QUERIES.M} {
    margin-bottom: 10px;
    border-radius: 4px;
  }
`

const DropZone = ({
  index,
}) => {
  return (
    <DropZoneDIV className="DropZone" />
  )
}

export default DropZone
